import type { CSSProperties } from 'react';

import { colorCategoria, suave } from '#components/mobile/ui/tokens';

import { claseSaltito } from './gaviCss';

type CajaEmojiProps = {
  /** Emoji del sistema de la categoría («🛒»). */
  emoji: string;
  /** Hueco de color de la categoría (0..11, `--p-k*`). */
  hueco: number;
  /** 44 px (filas de categorías) o 36 (versión pequeña). */
  size?: 44 | 36;
  /** Da un saltito (al marcar la categoría). Quieto con «reducir movimiento». */
  salta?: boolean;
  style?: CSSProperties;
};

/**
 * Emoji de categoría dentro de una caja teñida con su color al 20 %: lo
 * mismo que se verá luego en el Plan y en Movimientos (acuerdo,
 * «Ilustraciones»).
 */
export function CajaEmoji({
  emoji,
  hueco,
  size = 44,
  salta = false,
  style,
}: CajaEmojiProps) {
  const grande = size === 44;
  return (
    <span
      aria-hidden
      data-testid="caja-emoji"
      className={salta ? claseSaltito : undefined}
      style={{
        overflow: 'hidden',
        width: size,
        height: size,
        borderRadius: grande ? 12 : 10,
        display: 'grid',
        placeItems: 'center',
        flex: 'none',
        fontSize: grande ? 21 : 17,
        lineHeight: 1,
        backgroundColor: suave(colorCategoria(hueco), 20),
        ...style,
      }}
    >
      {emoji}
    </span>
  );
}
